import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function CONTACT_US() {
  return (
    <div className="container">
      <div className="row">
        <div className="footer-col">
          <h4>The White Dental</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/service">Services</Link>
            </li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Address</h4>
          <ul>
            <li>
              <h1>The White Dental</h1>
            </li>
            <li>
              <h2>Shop No 9, C Block Market</h2>
            </li>
            <li>
              <h2>East of Kailash</h2>
            </li>
            <li>
              <h2>New Delhi 110065</h2>
            </li>
            <li>
              <h2>Call Us :- 9013872365 </h2>
            </li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Timings</h4>
          <ul>
            <li>
              <h2>
                Monday &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 10:00AM-8:00PM
              </h2>
            </li>
            <li>
              <h2>
                Tuesday&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;10:00AM-8:00PM
              </h2>
            </li>
            <li>
              <h2>Wednesday &nbsp;10:00AM-8:00PM</h2>
            </li>
            <li>
              <h2>Thursday &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10:00AM-8:00PM</h2>
            </li>
            <li>
              <h2>
                Friday
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10:00AM-8:00PM
              </h2>
            </li>
            <li>
              <h2>
                Saturday &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10:00AM-8:00PM
              </h2>
            </li>
            <li>
              <h2>
                Sunday&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Holiday
              </h2>
            </li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>follow us</h4>
          <div className="social-links">
            <Link to="https://www.facebook.com">
              <i className="fab fa-facebook-f"></i>
            </Link>
            <Link to="https://www.google.com">
              <i className="fab fa-twitter"></i>
            </Link>
            <Link to="/">
              <i className="fab fa-linkedin-in"></i>
            </Link>
          </div>
        </div>
        <div className="center">
          Copyright &copy; www.WhiteDental.com 
          <br/>All right reserved
        </div>
      </div>
    </div>
  );
}

export default CONTACT_US;
